export function clone (actualObject) {
  if (Array.isArray(actualObject)) {
    return cloneArray(actualObject)
  } else if (typeof actualObject === 'object') {
    return cloneObject(actualObject)
  }
  return null
}

function cloneObject (actualObject) {
  let cloneObject = {}
  for (let property in actualObject) {
    cloneObject[property] = actualObject[property]
  }
  return cloneObject
}

function cloneArray (actualObject) {
  return actualObject.slice()
}

export function breadthFirstSearch (testInput, attr, value) {
  for (let prop in testInput) {
    if (attr === prop) {
      if (!hollow(value)) {
        testInput[attr] = value
        console.log(testInput, attr, value)
      }
      return true
    } else if (typeof testInput[prop] === 'object' && !Array.isArray(testInput[prop])) {
      if (breadthFirstSearch(testInput[prop], attr, value)) {
        return true
      }
    }
  }
  return false
}

export function notNullCopy (testInput) {
  Object.keys(testInput).forEach(key => {
    if (testInput[key] && typeof testInput[key] === 'object') notNullCopy(testInput[key])
    else if (testInput[key] == null) delete testInput[key]
  })
  return testInput
}

export function merge (reference, testInput) {
  let referenceClone = clone(reference)
  for (let attr in testInput) {
    if (typeof testInput[attr] === 'object' && !Array.isArray(testInput[attr])) {
      referenceClone[attr] = merge(referenceClone[attr], testInput[attr])
    } else {
      referenceClone[attr] = testInput[attr]
    }
  }
  return referenceClone
}

export function hollow (testInput) {
  if (
    typeof testInput === 'undefined' ||
    testInput === null ||
    (
      typeof testInput === 'number' &&
      isNaN(testInput)
    )
  ) {
    return true
  }
  return false
}

export function objectEqualForSameKeys (obj1, obj2) {
  for (var key in obj1) {
    if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
      return objectEqualForSameKeys(obj1[key], obj2[key])
    } else if (obj1[key] !== obj2[key]) {
      return false
    }
  }
  return true
}

export function jsonIsObjectEqual (obj1, obj2) {
  return JSON.stringify(obj1) === JSON.stringify(obj2)
}



// WEBPACK FOOTER //
// ./src/Services/objectModifier.js